import variables from '../variables';

const MuiChip = {
  styleOverrides: {
    root: {
      borderStyle: 'solid',
      height: 35,
      justifyContent: 'space-between',
      ...variables.chip,
    },
  },
};

export default MuiChip;
